<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild hidden-xs">
      <div>
        <div class="container">
          <!-- <span class="login-top">
            <img src="../assets/img/WY1/顶部LOGO.png" alt="">
          </span> -->
          <div class="server pull-left">
          <span class="glyphicon glyphicon-time"></span>
          德州大師，專業精緻的德州直觀！
        </div>
          <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
          
        </div>

      </div>
    </div>
    <!-- 电脑导航 -->
    <div class="header-nav container">
      <!-- 导航logo -->
      <div class="header-nav-logo">
        <img style="width: 60%;height:60%" src="@/assets/img/logo.png" />
      </div>
      <!-- 导航内容 -->
      <!-- <div>
        {{ countdown }}
  <span id="days"></span> 天
  <span id="hours"></span> 小时
  <span id="minutes"></span> 分钟
  <span id="seconds"></span> 秒
</div> -->
      <!-- {{ navList }} -->
      <!-- <ul class="header-nav-wrapper"> -->
        <ul class="header-nav-wrapper">
        <li
          v-for="(item,index) in navList"
          :key="index"
          :class="index==navIndex?'active':''"
          @click="navClick(index,item.name)"
        >
          <router-link :to="item.path">
          <span v-if="item.path === '/'">
            {{$t('home')}}
          </span>
          <span v-else-if="item.path === '/companyintroduction'">
            {{$t('about') }}
          </span>
          <span v-else>
            {{$t('contact') }}
          </span>
            <span v-if="item.children.length>0" class="glyphicon glyphicon-menu-down"></span>
            <i class="underline"></i>
          </router-link>
        </li>
      </ul> 
      <!-- <div class="nav-container">
        sdfhsdkjfhsk


      </div> -->

      <!-- <div class="nav-bg">

      </div> -->
             <!-- <span class="dropdown">
                <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                  {{ currentLanguage }}
                  <span class="caret"></span>
                </button>
                <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">

                  <li
                    v-for="(item,index) in languageList"
                    :key="index"
                  
                    @click="handleChangeLanguage(item.value,item.name)"
                  >
                  <a href="#">{{item.name}}</a>
                  
                  </li>
                </ul>
             </span> -->
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs">
      <!-- <div class="header-nav-m-logo"> -->
        <!-- <img class="center-block" src="@/assets/img/logo.png" alt="logo"> -->
        <!-- <span class="dropdown">
            <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
              {{ currentLanguage }}
              <span class="caret"></span>
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">

              <li
                v-for="(item,index) in languageList"
                :key="index"
              
                @click="handleChangeLanguage(item.value,item.name)"
              >
              <a href="#">{{item.name}}</a>
              
              </li>
            </ul>
         </span> -->
      <!-- </div> -->
      <!-- 导航栏 -->
      <div class="header-nav-m-menu text-center">
        <span v-if="menuName === '首页'">
          {{$t('home')}}
        </span>
        <span v-else-if="menuName === '关于我们'">
          {{$t('about')}}
        </span>
        <span v-else>
          {{$t('contact')}}
        </span>
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
        <!-- 导航内容 -->
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item,index) in navList"
            :key="index"
            :class="index==navIndex?'active':''"
            @click="navClick(index,item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              <!-- {{item.name}} -->
              <span v-if="item.path === '/'">
            {{$t('home')}}
          </span>
          <span v-else-if="item.path === '/companyintroduction'">
            {{$t('about') }}
          </span>
          <span v-else>
            {{$t('contact') }}
          </span>
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      countdown: '',
      currentLanguage: "简体中文",
      languageList: [
        {name: "简体中文", value: "zn"},
        {name: "ENGLISH", value: "en"}
      ],
      navIndex: sessionStorage.getItem('navIndex') ? sessionStorage.getItem('navIndex') : 0,
      menuName: "首页",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [
        {
          
          name: "首页",
          path: "/",
          children: []
        },
        // {
        //   name: "软件产品",
        //   path: "/software",
        //   children: [
        //     {
        //       name: "智能小镇管理系统",
        //       path: "/software/smartTown"
        //     },
        //     {
        //       name: "大数据管理系统",
        //       path: "/software/bigData"
        //     }
        //   ]
        // },
        // {
        //   name: "相关服务",
        //   path: "/service",
        //   children: []
        // },
        // {
        //   name: "新闻动态",
        //   path: "/newsinformation",
        //   children: []
        // },
        {
          name: "关于我们",
          path: "/companyintroduction",
          children: []
        },
        // {
        //   name: "工作机会",
        //   path: "/jobchance",
        //   children: []
        // },
        {
          name: "联系我们",
          path: "/contactus",
          children: []
        }
      ]
    };
  },
  mounted() {
    this.startCountdown();
  },
  methods: {
    startCountdown() {
      const targetDate = new Date('2023-10-22T19:00:00');
      setInterval(() => {
        const currentDate = new Date();
        const timeDifference = targetDate - currentDate;

        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        this.countdown = `${days} 天 ${hours} 小时 ${minutes} 分钟 ${seconds} 秒`;
      }, 1000);
    },
  
    handleChangeLanguage(value,name) {
      console.log(name, value,  "sdfjsdkfjsdk")
      localStorage.setItem('lang', value)
      this.$i18n.locale = value
      this.currentLanguage = name;

    },
    navClick(index, name) {
      this.navIndex = index;
      sessionStorage.setItem('navIndex',index)
      this.menuName = name;
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    }
  }
};
</script>
<style scoped>
/* 顶部 */
#header {
  background: #f4f4f4;
  transition: all ease 0.6s;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
.header-container {
  line-height: 140px;
  padding-top: 30px;
  padding-left: 364px;
}
/* 顶部的图标 */
#header .header-top span {
  /* margin: 0 8px; */
}
/* 导航栏 */
#header .header-nav {
  height: 110px;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100px;
  float: left;
  padding-top: 20px;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 95px;
  height: 45px;
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  line-height: 110px;
  float: right;
  margin: 0;
  max-width: 800px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #000;
  font-size: 15px;
  font-weight: bold;
  padding: 15px 0;
  position: relative;
}
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  color: #1e73be;
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  color: #1e73be;
  text-decoration: none;
  border-bottom: 2px solid #1e73be;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #ccc;
  background: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid #ccc;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background: #ccc;
}
@media screen and (max-width: 997px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏logo容器 */
  #header .header-nav-m .header-nav-m-logo {
    /* width: 100px; */
    height: 100px;
    position: relative;
    /* overflow: hidden; */
  }

  .dropdown {
    position: absolute !important;
    top: 0 !important;
    right: 0px !important;

  }
  /* 导航栏logo图片 */
  #header .header-nav-m .header-nav-m-logo img {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: #474747;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: #474747;
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px 0;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
}
.dropdown {
  /* float: right; */
  position: absolute;
  top: 45px;
  right: 0px;
  width: 100px;
  line-height: 120px;
  margin-right: 20px;
  cursor: pointer;
}

.nav-container {
  width: 100%;
  height: 80px;
  background: url('../assets/img/WY1/导航栏.png') no-repeat;
  background-size: 100% 100%;
}
.nav-bg {
  height: 500px;
  width: 100%;
  background: url('../assets/img/WY1/背景.png')  no-repeat;
  /* background-size: 100% 100%; */
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue